import React from "react";
import { Box, Image, Heading, SubHeading } from "./StyledComponents";

const PaymentSuccessBox = ({ image }) => {
    return (
        <Box>
            <Image src={image || "/placeholder.svg"} alt="Payment Success" />
            <Heading>Payment Done!</Heading>
            <SubHeading>
                Your payment has been successfully processed! There
                are no pending dues at the moment. Thank you!
            </SubHeading>
        </Box>
    );
};

export default PaymentSuccessBox;